export default __webpack_public_path__ + "assets/images/3550d2d89eddda2bdf70e65f72823a9c.svg";